import React, { useState } from 'react'
import { Mutation } from 'react-apollo'
import { useQuery } from '@apollo/react-hooks'
import { Link } from 'react-router-dom'
import moment from 'moment'
import FileDownload from 'js-file-download'
import axios from 'axios'
import {
  message, Menu, Dropdown, Icon, Select as AntdSelect, Button as AntdButton, Modal, DatePicker, Radio,
} from 'antd'
import _ from 'lodash'
import {
  SmallText, Div, Button, Loading, P,
} from 'konsys-ui'
import history from '../../history'
import { theme } from '../../styles/_variables'
import { status, statusText } from '../../pages/truck-page/constants'
import { UPDATE_TRUCK } from '../../constants/graphql/mutation'
import { GET_FLEETS } from '../../constants/graphql/query'
import { Text } from './styled'
import PERMISSION from '../../constants/permissions'
import { getAccessToken, getURL } from '../../utils/local-data-service'
import { compressFiles } from '../../pages/shipping-order-page/detail/extension-components'

const { color } = theme

export const CellText = props => (
  <Text font='sarabun' {...props}>{props.children}</Text>
)

export const HeaderLabel = props => (
  <SmallText bold color={color.coolGrey} font='sarabun' style={{ fontWeight: 700 }}>{props.children}</SmallText>
)

export const InputWithPlaceHolder = ({ handleChange }) => (
  <input placeholder='ค้นหา' onChange={e => handleChange(e.target.value)}/>
)

export const DropdownSelector = ({
  data, handleChange, typeNameTh,
}) => {
  const width = typeNameTh ? '120px' : '100px'
  return (
    <AntdSelect
      defaultValue='ทั้งหมด'
      dropdown
      maxHeight='none'
      style={{ width }}
      onChange={e => (e === 'ALL' ? handleChange('') : handleChange(e))}
    >
    {
      data.map(v => <AntdSelect.Option key={v.value} value={v.value}>{v.text}</AntdSelect.Option>)
    }
    </AntdSelect>
  )
}

export const StatusSelector = ({ handleChange, filter, disabled }) => {
  const arr = [
    { value: status.AVAILABLE, text: statusText.AVAILABLE },
    { value: status.REPAIRING, text: statusText.REPAIRING },
    { value: status.OUT_OF_SERVICE, text: statusText.OUT_OF_SERVICE },
    { value: status.WATCHING, text: statusText.WATCHING },
    { value: status.ACCIDENT, text: statusText.ACCIDENT },
    { value: status.NO_DRIVER, text: statusText.NO_DRIVER },
    { value: status.IN_USE, text: statusText.IN_USE },
  ]

  const filterer = filter ? _.concat({ value: 'ALL', text: 'ทั้งหมด' }, arr) : arr

  return (
    <AntdSelect
      defaultValue="ทั้งหมด"
      dropdown
      disabled={disabled}
      style={{ width: '100%' }}
      onChange={e => handleChange(e)}
    >
    {
      filterer.map(v => <AntdSelect.Option key={v.value} value={v.value}>{v.text}</AntdSelect.Option>)
    }
    </AntdSelect>
  )
}

export const StatusCell = ({ disabled, props, refetch }) => {
  const [value, setValue] = useState(statusText[props.value])
  const arr = [
    { value: status.AVAILABLE, text: statusText.AVAILABLE },
    { value: status.REPAIRING, text: statusText.REPAIRING },
    { value: status.OUT_OF_SERVICE, text: statusText.OUT_OF_SERVICE },
    { value: status.WATCHING, text: statusText.WATCHING },
    { value: status.ACCIDENT, text: statusText.ACCIDENT },
    { value: status.NO_DRIVER, text: statusText.NO_DRIVER },
    { value: status.IN_USE, text: statusText.IN_USE },
  ]
  return (
    <Mutation
        mutation={UPDATE_TRUCK}
      >
      {(doUpdateTruck, { loading }) => {
        if (loading) return <Loading/>
        return (
        <Div>
          <AntdSelect
            value={value}
            disabled={disabled}
            dropdown
            maxHeight="none"
            style={{
              backgroundColor: '#00000000',
              color: value === statusText.AVAILABLE
                ? color.success
                : value === statusText.REPAIRING
                  ? color.warning
                  : color.error,
              width: '120px',
            }}
            onChange={(e) => {
              setValue(statusText[e])
              doUpdateTruck({
                variables: {
                  id: props.original.id,
                  status: e,
                },
              }).then((resp) => {
                const response = resp.data.UpdateTruck
                if (response.success) {
                  message.success(response.message)
                  refetch()
                } else message.error(response.message)
              })
            }}
          >
          {
            arr.map(v => <AntdSelect.Option key={v.value} value={v.value}>{v.text}</AntdSelect.Option>)
          }
          </AntdSelect>
        </Div>
        )
      }}
    </Mutation>
  )
}

const menu = id => (
  <Div>
    <Menu>
      <Menu.Item key='view' disabled={!_.includes(window.perms, PERMISSION.VIEW_TRUCK)}>
        <Link target="_blank" to={`/truck/view/${id}`}>
          ดูรายละเอียด
        </Link>
      </Menu.Item>
      <Menu.Item key='view-log' disabled={!_.includes(window.perms, PERMISSION.VIEW_TRUCK)}>
        <Link target="_blank" to={`/truck/view-log/${id}`}>
          ดูประวัติการใช้งาน
        </Link>
      </Menu.Item>
      <Menu.Item key='view-driver-log' disabled={!_.includes(window.perms, PERMISSION.VIEW_TRUCK)}>
        <Link target="_blank" to={`/truck/driver-history/${id}`}>
          ดูประวัติการเปลี่ยนคนขับ
        </Link>
      </Menu.Item>
      <Menu.Item key='tire-list' disabled={!_.includes(window.perms, PERMISSION.VIEW_TRUCK)}>
        <Link target="_blank" to={`/truck/tire-list/${id}`}>
          ดูข้อมูลล้อ
        </Link>
      </Menu.Item>
      <Menu.Item key='tire-history-list' disabled={!_.includes(window.perms, PERMISSION.VIEW_TRUCK)}>
        <Link target="_blank" to={`/truck/tire-history/${id}`}>
          ดูประวัติการใช้ยาง
        </Link>
      </Menu.Item>
      <Menu.Item key='edit' disabled={!_.includes(window.perms, PERMISSION.UPDATE_TRUCK)}>
        <Link target="_blank" to={`/truck/edit/${id}`}>
          แก้ไข
        </Link>
      </Menu.Item>
    </Menu>
  </Div>
)

export const ActionSelector = ({ props: { original: { id } } }) => (
  <Dropdown overlay={menu(id)} trigger='click'>
    <AntdButton>
      ดูรายละเอียด <Icon type="down" />
    </AntdButton>
  </Dropdown>
)

export const Wrapper = props => (
  <Div
    display='block'
    width='100%'
    padding={props.padding || '40px 0'}
    justifyContent={props.center && 'center'}
    style={{ borderBottom: `1px solid ${color.paleGrey}`, overflow: props.overflow && 'auto' }}
  >
    {props.children}
  </Div>
)

const RepairExpenseModal = ({
  repairExpenseModal, setRepairExpenseModal, isLoading, setIsLoading, props, pdfInfo,
}) => {
  const [range, setRange] = useState([])
  return (
    <Modal
      title="พิมพ์ค่าใช้จ่ายของการซ่อมรถบรรทุก"
      visible={repairExpenseModal}
      destroyOnClose={true}
      onCancel={() => {
        setRepairExpenseModal(false)
        setRange([])
      }}
      onOk={() => {
        setIsLoading(true)
        axios({
          method: 'GET',
          responseType: 'blob',
          headers: {
            Authorization: `Bearer ${getAccessToken()}`,
          },
          url: `${getURL().FILE_SERVER}/download/excel/truck/tire/expense?${
            [
              `startDate=${moment(range[0]).format('YYYY-MM-DD')}`,
              `endDate=${moment(range[1]).format('YYYY-MM-DD')}`,
              `truckId=${props.match.params.id}`,
            ].join('&')
          }`,
        }).then((resp) => {
          FileDownload(resp.data, `พิมพ์ค่าใช้จ่ายของการซ่อมรถบรรทุกวันที่ ${moment(range[0]).format('YYYY-MM-DD')} - ${moment(range[1]).format('YYYY-MM-DD')} ของทะเบียน ${pdfInfo.platenumber}.xlsx`)
          setIsLoading(false)
          setRepairExpenseModal(false)
          setRange([])
        })
      }}
      okButtonProps={{
        disabled: isLoading || _.isUndefined(range),
        loading: isLoading,
      }}
      cancelButtonProps={{
        disabled: isLoading,
      }}
    >
      <Div alignItems='center' display='flex' flexDirection='row'>
        <P margin = '0 32px 0 0'>เลือกวันที่</P>
        <DatePicker.RangePicker
          format='DD/MM/YYYY'
          onChange={(e) => {
            setRange(e)
          }}
        />
      </Div>
    </Modal>
  )
}

export const ActionBar = ({
  loading, isAddMode, isViewMode, doAction, mutationVariables, props, disabled, pdfInfo,
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const [repairExpenseModal, setRepairExpenseModal] = useState(false)
  const [compensateModal, setCompensateModal] = useState(false)
  const [month, setMonth] = useState()
  const [date, setDate] = useState([])
  const [text, setText] = useState([])
  const [radio, setRadio] = useState()
  const [repairModal, setRepairModal] = useState(false)

  const download = (id, selectedDate) => {
    setIsLoading(true)
    window.open(
      `${getURL().FILE_SERVER}/downloadfile/pdf/generateHtmlPadoongrichDriverCompensationPdf/${id}?start=${moment(selectedDate[0]).format('YYYY-MM-DD')}&end=${moment(selectedDate[1]).format('YYYY-MM-DD')}&t=${getAccessToken()}`,
      '_blank',
      'toolbar=false,scrollbars=yes,resizable=false',
    )
    setIsLoading(false)
  }

  return (
    <Div
      position='fixed'
      height='72px'
      bottom='0'
      left='0'
      right='0'
      style={{ background: `${color.primaryColor}33` }}
      display='flex'
      justifyContent='flex-end'
      alignItems='center'
      padding='0 32px 0 0'
    >
      <Button disabled={isAddMode} margin='0 16px 0 0' text='พิมพ์รายงานค่ายาง' icon='fas fa-print' onClick={() => setRepairExpenseModal(true)} />
      <Button disabled={isAddMode} margin='0 16px 0 0' text='พิมพ์รายงานค่าใช้จ่ายงานซ่อม' icon='fas fa-print' onClick={() => setRepairModal(true)} />
      <Button disabled={isAddMode} margin='0 16px 0 0' text='พิมพ์ข้อมูลเบี้ยเลี้ยง' icon='fas fa-print' onClick={() => setCompensateModal(true)} />
      <Button
        loading={loading}
        disabled={loading || (isViewMode && !_.includes(window.perms, PERMISSION.UPDATE_TRUCK)) || disabled}
        text={isAddMode ? 'สร้างใหม่' : isViewMode ? 'แก้ไข' : 'บันทึก'}
        icon={isAddMode ? 'fas fa-plus' : isViewMode ? 'fas fa-edit' : 'fas fa-save'}
        inverse
        onClick={async () => {
          if (isViewMode) history.push(`/truck/edit/${props.match.params.id}`)
          else {
            let variables = _.cloneDeep(mutationVariables)
            const truckFilesToCompress = _.cloneDeep(mutationVariables.truckFiles) || []
            const needCompression = (truckFilesToCompress && truckFilesToCompress?.length > 0)

            if (needCompression) {
              try {
                const compressedTruckFiles = await compressFiles(truckFilesToCompress)
                variables = {
                  ...variables,
                  truckFiles: compressedTruckFiles,
                }
              } catch (err) {
                message.error('เกิดข้อผิดพลาดในการบีบอัดไฟล์')
              }
            }
            doAction({
              variables: isAddMode ? { ...variables } : { id: parseInt(props.match.params.id, 10), ...variables },
            }).then(({ data }) => {
              const resp = isAddMode ? data.CreateTruck : data.UpdateTruck

              if (resp.success) {
                message.success(resp.message)

                if (isAddMode) history.push('/truck')
                // else history.push(`/truck/view/${props.match.params.id}`)
              } else message.error(resp.message)
            })
          }
        }}
      />
      <RepairExpenseModal
        repairExpenseModal={repairExpenseModal}
        setRepairExpenseModal={setRepairExpenseModal}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
        props={props}
        pdfInfo={pdfInfo}
        />
      <Modal
        title="เลือกวันที่เริ่ม-สิ้นสุด"
        visible={compensateModal}
        onCancel={() => {
          setCompensateModal(false)
          setMonth()
          setRadio()
          setDate([])
        }}
        destroyOnClose={true}
        onOk={() => {
          download(props.match.params.id, date)
          setMonth()
          setRadio()
          setDate([])
        }}
        okButtonProps={{
          disabled: date.length < 2 || isLoading,
          loading: isLoading,
        }}
        cancelButtonProps={{
          disabled: isLoading,
        }}
      >
        <Div display='flex' justifyContent='space-between' alignItems='center' flexDirection='column'>
          <DatePicker.MonthPicker placeholder='เลือกเดือน' onChange={(e) => {
            setMonth(e)
            setRadio()
            setDate([])
          }} style={{ width: '100%' }}/>
          <Radio.Group style={{ width: 'fit-content', margin: '16px 0' }} onChange={(e) => {
            setRadio(e.target.value)
            switch (e.target.value) {
              case 'month':
                setDate([moment(month).startOf('month'), moment(month).add('months', 1).date(0)])
                setText('ทั้งเดือน')
                break
              case 'first':
                setDate([moment(month).startOf('month'), moment(`${month.format('Y')}-${month.format('M')}-10`)])
                setText('วันที่ 1-10')
                break
              case 'middle':
                setDate([moment(`${month.format('Y')}-${month.format('M')}-11`), moment(`${month.format('Y')}-${month.format('M')}-20`)])
                setText('วันที่ 11-20')
                break
              case 'last':
                setDate([moment(`${month.format('Y')}-${month.format('M')}-21`), moment(month).add('months', 1).date(0)])
                setText('วันที่ 21-สิ้นเดือน')
                break
              default:
                setDate(undefined)
                break
            }
          }} disabled={_.isUndefined(month)} value={radio}>
            <Radio.Button value='month'>ทั้งเดือน</Radio.Button>
            <Radio.Button value='first'>วันที่ 1-10</Radio.Button>
            <Radio.Button value='middle'>วันที่ 11-20</Radio.Button>
            <Radio.Button value='last'>วันที่ 21-สิ้นเดือน</Radio.Button>
          </Radio.Group>
        </Div>
      </Modal>
      <Modal
        title="รายงานค่าใช้จ่ายงานซ่อม"
        visible={repairModal}
        onCancel={() => {
          setRepairModal(false)
          setDate([])
        }}
        destroyOnClose={true}
        onOk={() => {
          setIsLoading(true)
          axios({
            method: 'GET',
            responseType: 'blob',
            headers: {
              Authorization: `Bearer ${getAccessToken()}`,
            },
            url: `${getURL().FILE_SERVER}/download/excel/truck/expense?startDate=${moment(date[0]).format('YYYY-MM-DD')}&endDate=${moment(date[1]).format('YYYY-MM-DD')}&truckId=${props.match.params.id}`,
          }).then((resp) => {
            FileDownload(resp.data, `รายงานค่าใช้จ่ายงานซ่อมของรถบรรทุกทะเบียน ${(pdfInfo && pdfInfo.platenumber) || ''} วันที่ ${moment(date[0]).format('YYYY-MM-DD')} - ${moment(date[1]).format('YYYY-MM-DD')} .xlsx`)
            setIsLoading(false)
            setRepairModal(false)
            setDate([])
          })
        }}
        okButtonProps={{
          disabled: date.length < 2 || isLoading,
          loading: isLoading,
        }}
        cancelButtonProps={{
          disabled: isLoading,
        }}
      >
      <Div display='flex' justifyContent='space-between' alignItems='center' flexDirection='row'>
      <P margin='16px 0'>เลือกวันที่</P>
      <DatePicker.RangePicker
        format='DD/MM/YYYY'
        onChange={(e) => {
          setDate(e)
        }}
      />
      </Div>
      </Modal>
    </Div>
  )
}
